export default (callback: CallableFunction): void => {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', () => callback(), {
      once: true,
    });
  }
};
